// i18next uses '.' as key separator and ':' as namespace separator, so both
// must be stored in locale files as underscores and normalized here.
export const normalizeFeatureKey = (key) => key?.replace(/[.:]/g, '_') ?? key;

// Convert a plan title like "Basic Supporter" to a camelCase locale key "basicSupporter".
export const titleToLocaleKey = (title) => {
  if (!title) return '';
  return title
    .replace(/\s+(\w)/g, (_, c) => c.toUpperCase())
    .replace(/^./, (c) => c.toLowerCase());
};
